import colorPalette from './colorPalette';

// const { COLOR_RED, COLOR_WHITE_SMOKE, COLOR_BLUE, COLOR_WHITE, COLOR_GREEN } = colorPalette;
const { COLOR_RED, COLOR_WHITE_SMOKE, COLOR_GREEN } = colorPalette;

const CIRLE_MARKER_CONFIG = {
  fillColor: COLOR_GREEN,
  fillOpacity: 0.2,
  strokeColor: COLOR_GREEN,
  strokeOpacity: 1,
  strokeWeight: 2,
};

// const DISTANCE_MARKER_CONFIG = {
//   path: 'M 0, 0 m -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0',
//   strokeOpacity: 1,
//   strokeWeight: 2,
//   strokeColor: COLOR_RED,
//   fillColor: COLOR_WHITE,
//   fillOpacity: 1,
//   scale: 1.5,
// };

const POLY_CONFIG = {
  strokeColor: COLOR_RED,
  strokeOpacity: .8,
  strokeWeight: 2,
};

const mapSettings = {
  clickableIcons: false,
  streetViewControl: false,
  panControlOptions: false,
  gestureHandling: 'greedy',
  backgroundColor: COLOR_WHITE_SMOKE,
  mapTypeControl: false,
  mapTypeId: 'hybrid', //roadmap, satellite, hybrid, terrain 
  scaleControl: true,
  zoomControl: true,
  center: { lat: 52, lng: 19 },
  zoom: 5,
  minZoom: 5,
  maxZoom: 20,
  styles: [],
  tilt:0
};

export { mapSettings, CIRLE_MARKER_CONFIG, POLY_CONFIG };
